<template>
  <div style="color: #555555;font-size: 18px;width: 100%;margin-left: auto;margin-right: auto;background-color: #E3DFEF;">
    <div style="width: 100%;height: auto;">
      <!-- 提示容器 -->
      <div id="topAlert" style="position: fixed; top: 60%; left: 50%; transform: translateX(-50%) translateY(-50%); padding: 10px 20px; border-radius: 5px; width: 60%; height: auto; font-size: 18px; line-height: 30px; text-align: center; color: #fff; z-index: 9999; display: none; box-shadow: 0 0 10px rgba(0, 0, 0, 0.25); background: #52c41a;">
        <div>Your email preferences have been updated.</div>
      </div>
      
<!-- 头部区域 -->
<div style="width: 100%;height: 80px;background-color: #4022B3; display: flex; align-items: center;">
  <div style="width: 2%;"></div>
  <div style="width: 4%; vertical-align: middle; min-width: 72px;">
    <img src="https://res.buddyfunny.com/email/icon.png" style="vertical-align: middle;">
  </div>
  <div style="width: 2%;"></div>
  <div style="width: 92%;">
    <div
      style="font-family: Microsoft YaHei;font-weight: bold;font-size: 20px;color: #FFFFFF;line-height: 36px; margin-left: 20px;">
      Hit Fortune - Casino Slots</div>
  </div>
</div>
      
      <!-- 标题区域 -->
      <div style="width: 100%;height: 150px;">
        <div
          style="font-family: Microsoft YaHei;font-weight: bold;font-size: 36px;color: #2B2B2B;text-align: center;line-height: 36px; padding: 30px 0;">
          Email Preference Centre</div>
        <div style="margin-left: 10%; width: 80%;height: 1px;background-color: #ABA7B6;margin-top: auto;">
        </div>
      </div>
      
      <!-- 主要内容区域 -->
      <div style="margin-left: 10%; width: 80%;margin-bottom: 45px;">
        <div style="font-size: 20px;">
          <div style="margin-top: 60px;line-height: 30px;text-align: center;">
            <p>Change the type of emails <span style="color: #4022B3;font-weight: 600;">{{email}}</span> is subscribed
              to : </p>
          </div>
        </div>
        
        <div style="display: flex; justify-content: center;">
          <form id="checkForm">
            <!-- 复选框 1 -->
            <div class="item">
              <input type="checkbox" id="ck1" checked style="width: 2em; height: 2em;">
              <label for="ck1">
                <span class="title">Push</span>
                <span>Promotional emails and account rewards</span>
              </label>
              <!-- 白色勾放大 2 倍 -->
              <div class="tick" style="left: 0.25em; top: 0.25em; font-size: 18px;">
                <svg width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 13L9 17L19 7" stroke="white" stroke-width="3" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          
            <!-- 复选框 2 -->
            <div class="item">
              <input type="checkbox" id="ck2" checked style="width: 2em; height: 2em;">
              <label for="ck2">
                <span class="title">Event</span>
                <span>Recall Event Notifications</span>
              </label>
              <div class="tick" style="left: 0.25em; top: 0.25em;">
                <svg width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 13L9 17L19 7" stroke="white" stroke-width="3" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </form>
        </div>
        
        <div style="margin-top: 60px;line-height: 30px; text-align: center;">
          <!-- 按钮替换 -->
          <button id="updateBtn"
            style="background-color: #ff00ae; color: white; max-width: 320px;font-size: 24px; height: 60px; border-radius: 10px;margin: 0 auto; border-style: none;">Update
            my preferences</button>
        </div>
        
        <div style="margin-top: 60px; height: 1px;background-color: #ABA7B6;margin-bottom: 60px;"></div>
        
        <div style="margin-bottom: 29px; text-align: center;">
          <div style="margin-top: 10px;">We use your preferences to tailor your email experience. You
            can update or unsubscribe anytime.</div>
        </div>
      </div>
      
      <!-- 底部区域 -->
<div style="width: 100%; background-color: #C9C4D6;">
  <div style="text-align: center; width: 100%;">
    <div style="margin-top: 45px; display: flex; align-items: center; justify-content: center; padding: 0 20px;padding-top:45px;">
      <div>
        <img src="https://res.buddyfunny.com/email/icon.png">
      </div>
      <div style="width: 20px;"></div>
      <div>
        <span
          style="font-family: Microsoft YaHei;font-weight: bold;font-size: 20px;color: #2B2B2B;line-height: 36px;">
          Hit Fortune - Casino Slots
        </span>
      </div>
    </div>
    
    <div
      style="margin-top: 21px;padding-bottom: 50px;font-family: Microsoft YaHei;font-weight: 400;font-size: 14px;color: #2B2B2B;line-height: 24px;">
      © 2025 Game Wonder Limited. All rights reserved.
    </div>
  </div>
</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmailPreferenceCentre",
  title: "EmailPreferenceCentreView",
  data() {
    return {
      isCheck1: true,
      isCheck2: true,
      email: '', // 如果需要动态显示邮箱地址
      scale: 1
    }
  },
  mounted() {
    this.syncVars();
    this.getRequiredParams()

    // 点击即同步
    document.getElementById('ck1').addEventListener('change', this.syncVars);
    document.getElementById('ck2').addEventListener('change', this.syncVars);

    // 绑定按钮
    document.getElementById('updateBtn').addEventListener('click', this.updatePreferences);
  },
  methods: {
    updateScale() {

    },
    
    syncVars() {
      this.isCheck1 = document.getElementById('ck1').checked;
      this.isCheck2 = document.getElementById('ck2').checked;
    },

    showTopAlert(success, msg) {
      const bar = document.getElementById('topAlert');
      bar.textContent = msg;
      // 移除之前的类
      bar.classList.remove('success', 'error');
      // 添加新的类
      bar.classList.add(success ? 'success' : 'error');
      bar.style.display = 'block';
      setTimeout(() => bar.style.display = 'none', 3000);
    },

    // 提取需要的参数
    getRequiredParams() {
      // 直接从 Vue Router 获取查询参数
      const query = this.$route.query;
      
      this.email = query.email || '';
      
      return {
        user_id: query.user_id || '',
        sign: query.sign || '',
        url: query.url || '',
      };
    },

    // 提交函数
    async updatePreferences() {
      const pushChecked = document.getElementById('ck1').checked;
      const eventChecked = document.getElementById('ck2').checked;
      this.isCheck1 = pushChecked;
      this.isCheck2 = eventChecked;

      // 获取URL中的参数
      const urlParams = this.getRequiredParams();

      const blockList = [];
      if (pushChecked) {
        blockList.push('1'); // Push未选中，加入屏蔽列表
      }
      if (eventChecked) {
        blockList.push('2'); // Event未选中，加入屏蔽列表
      }

      try {
        // ===== 模拟接口调用 =====
        // 兼容，如果有url参数，就使用url参数，没有就使用默认的接口
        let baseUrl = "https://api.buddyfunny.com"
        if (urlParams.url && urlParams.url.trim() !== '') {
          baseUrl = urlParams.url;
        }
        const res = await fetch(`${baseUrl}/v1/user/set_block_email`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json' // 添加这一行
          },
          body: JSON.stringify({
            user_id: parseInt(urlParams.user_id),
            sign: urlParams.sign,
            block_list: blockList.join('|') || ''
          }) // block_list 是屏蔽列表 1 pust, 2 event
        });
        if (!res.ok) throw new Error('Request failed: your email preferences were not updated.');

        const result = await res.json();

        if (result && result.code === 1) {
          this.showTopAlert(true, 'Your email preferences have been updated.');
        } else {
          this.showTopAlert(false, 'Request failed: your email preferences were not updated.');
        }

      } catch (e) {
        this.showTopAlert(false, e.message || 'Request failed: your email preferences were not updated.');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
body {
  font-family: Arial, Helvetica, sans-serif;
  background: #f7f7f7;
  padding: 0;
  margin: 0;
}

.item {
  display: flex;
  align-items: flex-start;
  margin: 1.5rem 0;
  position: relative;
  /* 添加最小高度确保有足够的空间 */
  min-height: 2.5em;
}


input {
  width: 2em;
  height: 2em;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 0.125rem solid #ff00ae;
  border-radius: 0.25rem;
  outline: none;
  cursor: pointer;
  flex-shrink: 0;
  /* 添加相对定位以作为子元素绝对定位的参考 */
  position: relative;
}

input:checked {
  background: #ff00ae url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M5 13L9 17L19 7' stroke='white' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") center center no-repeat;
  background-size: 1.5em 1.5em;
}

input:not(:checked) {
  background: #fff
}

label {
  margin-left: 1.5rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  flex: 1; /* 让标签占据剩余空间 */
}

label .title {
  color: #000;
  font-weight: 600
}

.tick {
  display: none !important;
}

input:checked + label + .tick {
  display: flex;
}

#topAlert.success {
  background: #52c41a !important; /* 使用 !important 确保优先级 */
}

#topAlert.error {
  background: #ff4d4f !important; /* 错误红 */
}
</style>